import {
    PercentageBarSegment,
    PercentageBarVisualization,
} from 'components/data/PercentageBarVisualization/PercentageBarVisualization';
import { DeployedShippedSummary } from 'types';
import { deployedColor, shippedColor } from 'store/services/device-status';
import styles from './DeployedShippedSummaryVisualization.module.scss';

export interface DeployedShippedSummaryVisualizationProps {
    /** Quantity information for the supplier's deployed vs shipped devices. */
    deployedShippedSummary: DeployedShippedSummary;
}

export const DeployedShippedSummaryVisualization = ({
    deployedShippedSummary,
}: DeployedShippedSummaryVisualizationProps) => {
    const shipped: PercentageBarSegment = {
        name: 'Shipped',
        tooltip: `${deployedShippedSummary.shippedCount} shipped devices`,
        backgroundColor: shippedColor,
        width:
            (deployedShippedSummary.shippedCount /
                (deployedShippedSummary.shippedCount +
                    deployedShippedSummary.deployedCount)) *
            100,
    };

    const deployed: PercentageBarSegment = {
        name: 'Deployed',
        tooltip: `${deployedShippedSummary.deployedCount} deployed devices`,
        backgroundColor: deployedColor,
        width:
            (deployedShippedSummary.deployedCount /
                (deployedShippedSummary.shippedCount +
                    deployedShippedSummary.deployedCount)) *
            100,
    };

    return (
        <div className={styles.DeployedShippedSummaryVisualization}>
            <PercentageBarVisualization
                testId="DeployedShippedSummaryVisualization"
                percentageBarSegments={[deployed, shipped]}
                label="Deployment"
            />
        </div>
    );
};
